import { useMemo } from 'react';

import { Bean, MoneyPatternType, ValidationRules } from '@dreryk/react-common';
import { MoneyInput, MoneyValue } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../translations';
import { ReceptionServiceFormController } from '../../ReceptionServiceForm';

export type ReceptionServicePriceValue = MoneyValue;

type ReceptionServicePriceMoneyInputProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServicePriceMoneyInput = (props: ReceptionServicePriceMoneyInputProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: true,
      };
   }, []);

   return (
      <MoneyInput
         testId={'price'}
         label={receptionServiceTranslationKeys.shared.form.components.priceMoneyInput.label}
         controller={props.register('price', validationRules)}
         pattern={MoneyPatternType.POSITIVE}
         min={1}
         max={999999.99}
         defaultValue={1}
         disabled={props.disabled}
         nowrap
      />
   );
};
